module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/VE-9b48a6ebd030a3a9d07b72d4557ec362.png";